// OBSOLETO - QUITAR REFERENCIAS A ESTE ENUM
export enum EnumEstadoViaje {
  Pendiente = 1,
  Anulado = 2,
  NoViable = 3,
  Viable = 4,
  Rechazado = 5
}
